<template>
  <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      data-v-4f7c6a64=""
      d="M10.5 0C4.977 0 0.5 4.477 0.5 10C0.5 15.523 4.977 20 10.5 20C16.023 20 20.5 15.523 20.5 10C20.5 4.477 16.023 0 10.5 0ZM14.5 11H11.5V14C11.5 14.552 11.052 15 10.5 15C9.948 15 9.5 14.552 9.5 14V11H6.5C5.948 11 5.5 10.552 5.5 10C5.5 9.448 5.948 9 6.5 9H9.5V6C9.5 5.448 9.948 5 10.5 5C11.052 5 11.5 5.448 11.5 6V9H14.5C15.052 9 15.5 9.448 15.5 10C15.5 10.552 15.052 11 14.5 11Z"
      fill="currentColor"></path>
  </svg>
</template>
